export default __webpack_public_path__ + "static/o3_satellite_rotation_cropped-ea4badc38f9cc5404cddb8682e51dc10.mp4";